import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Mail, Phone } from "lucide-react";

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/consultations").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <p className="font-mono text-clay text-sm">加载中…</p>;

  return (
    <div>
      <h1 className="font-serif text-4xl tracking-tight mb-2">Study-in-China Enquiries</h1>
      <p className="text-clay mb-8">Consultation requests submitted by prospective students.</p>

      {items.length === 0 ? (
        <div className="border border-black/10 bg-white p-12 text-center text-clay">No enquiries yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((c) => (
            <div key={c.consultation_id} className="border border-black/10 bg-white p-6" data-testid={`enquiry-${c.consultation_id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-display font-bold text-lg">{c.name}</h3>
                  <p className="label text-gold mt-1">{c.topic}</p>
                </div>
                <span className="text-[10px] uppercase tracking-widest px-2 py-1 bg-cinnabar/10 text-cinnabar">{c.status}</span>
              </div>
              <p className="text-sm text-clay mt-3 whitespace-pre-wrap">{c.message}</p>
              <div className="mt-4 pt-3 border-t border-black/10 flex flex-wrap gap-4 text-xs text-clay">
                <span className="flex items-center gap-1.5"><Mail size={13} /> {c.email}</span>
                {c.phone && <span className="flex items-center gap-1.5"><Phone size={13} /> {c.phone}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
